import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.50078 0.866211L0.800781 4.73288V10.5329C0.800781 15.8979 4.51278 20.9149 9.50078 22.1329C14.4888 20.9149 18.2008 15.8979 18.2008 10.5329V4.73288L9.50078 0.866211ZM12.4781 15.3662L9.50078 13.5779L6.53311 15.3662L7.31611 11.9829L4.69645 9.72088L8.15711 9.42121L9.50078 6.23121L10.8444 9.41154L14.3051 9.71121L11.6854 11.9829L12.4781 15.3662Z"
      fill="#222A5C"
    />
  </svg>,
  "BundleFilled"
);
